
export const getImagePath = (imagePath) => {
    return `/earthquake-page/${imagePath}`;
};

